import axios from 'axios';

import { ApiResponse } from '../types/ApiResponse';
import { useAuthStore } from '../stores/useAuthStore';

export const getRefreshToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  const cookies = document.cookie.split(';');
  const refreshTokenCookie = cookies.find((cookie) =>
    cookie.trim().startsWith('refreshToken='),
  );
  return refreshTokenCookie ? refreshTokenCookie.split('=')[1] : null;
};

// 환경별 baseURL 설정
const getBaseURL = (): string => {
  const nodeEnv = process.env.NODE_ENV;
  const reactAppEnv = process.env.REACT_APP_ENV;

  // local 환경: 프록시 사용으로 빈 문자열 반환
  if (nodeEnv === 'development' && reactAppEnv === 'local') {
    return '';
  }

  // dev 환경
  if (reactAppEnv === 'dev') {
    return process.env.REACT_APP_API_BASE_URL || '';
  }

  // prod 환경
  if (reactAppEnv === 'prod') {
    return process.env.REACT_APP_API_BASE_URL || '';
  }

  // 기본값 (환경변수 또는 빈 문자열)
  return process.env.REACT_APP_API_BASE_URL || '';
};

const apiToken = axios.create({
  baseURL: getBaseURL(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiToken.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers?.Authorization) {
    delete config.headers.Authorization;
  }

  return config;
});

export const isSuccess = (response: ApiResponse): boolean => {
  return response.statusCode === 200;
};

export const handleApiError = (error: any): string => {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return 'An error occurred';
};

export default apiToken;
